import { Pipe, PipeTransform } from '@angular/core';
import { parseISO } from 'date-fns';
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
import { toDateFnsPattern } from './moment-pattern';

const TIME_ZONE = 'America/Sao_Paulo';
const DEFAULT_PATTERN = 'dd/MM/yyyy';

const HAS_OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i;

@Pipe({ name: 'dateFormat', standalone: true })
export class DateFormatPipe implements PipeTransform {
  transform(
    value: string | number | Date | null | undefined,
    pattern: string = DEFAULT_PATTERN
  ): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const date = this.toDate(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    return formatInTimeZone(date, TIME_ZONE, toDateFnsPattern(pattern));
  }

  private toDate(value: string | number | Date): Date {
    if (typeof value !== 'string') {
      return new Date(value);
    }
    return HAS_OFFSET.test(value) ? parseISO(value) : fromZonedTime(value, TIME_ZONE);
  }
}
